import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/gallery/subscription')({
  beforeLoad: () => {
    throw redirect({ to: '/gallery/subscription', search: (prev) => prev });
  },
});
